"use client"

import { Tally1 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Tally1Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Tally1Icon = component(Icon)({ as: Tally1 })
